// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class RenderedAsset {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, asset, group, duplicates) {
        this.assetId = model.assetId;
        this.fileName = model.fileName;
        this.sourceUrl = model.sourceUrl;
        this.originalName = model.originalName;
        this.asset = asset;
        this.group = group;
        this.scale = model.settings.scale;
        this.format = model.settings.format;
        this.previouslyDuplicatedNames = duplicates;
    }
}
